// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"312":"6f8241b6a1485baf","971":"3ca862b53dfb3306","1021":"4c8085e3fa5ba34a","1195":"cad926f816a7b36e","1375":"ded4cf58f33a92eb","6380":"1fb59cb3b8a3d546","6835":"2efa15687138598f","7212":"7528c1641a4afd4f","9310":"a0c254f51c1cc4bf"}[chunkId] + ".js";
};